export const Logo = ({ className = "h-9 w-9" }) => (
  <img
    src="/vps-crest.png"
    alt="Vanguard Prep School crest"
    className={`${className} rounded-lg bg-black object-contain p-0.5`}
  />
);
